//import { ProductDetail, ProductList } from "../components";
import {  Home, SignIn,SignUp, TermsAndConditions,PrivacyPolicy, ContactUs, AboutUs, SearchResults, Membership } from "../pages";
import ForgotPasswordOtp from "../pages/ForgotPasswordOtp";
import ResetPassword from "../pages/ResetPassword";
export const authRoutes = [
    {
        path : '/login',
        element : <SignIn/>,
    },
    {
        path : '/signup',
        element : <SignUp/>,
    },
]
 
export const contentRoutes = [
    // {
    //     path : '/product/:id',
    //     element : <ProductDetail/>,
    // },
    // {
    //     path : '/productlist',
    //     element : <ProductList/>,
    // },
    // {
    //     path : '/cancellation',
    //     element : <CancelationAndRefund/>,
    // },
    // {
    //     path : '/shipping',
    //     element : <ShippingAndDelivery/>,
    // },
    {
        path : '/privacypolicy',
        element : <PrivacyPolicy/>,
    },
    {
        path : '/contactus',
        element : <ContactUs/>,
    },
    {
        path : '/aboutus',
        element : <AboutUs/>,
    },
    // {
    //     path : '/offlinestore',
    //     element : <Offlinestore/>,
    // },
    {
        path : '/forgot-otp',
        element : <ForgotPasswordOtp/>,
    },
    // {
    //     path : '/settings',
    //     element : <Settings/>,
    // },
    {
        path : '*',
        element : <Home/>,
    },
    {
        path : '/search',
        element : <SearchResults/>,
    },
    {
        path : '/reset-password',
        element : <ResetPassword/>,
    },
    {
        path : '/membership',
        element : <Membership/>,
    },{
        path : '/terms',
        element : <TermsAndConditions/>,
    },
];